
const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import SeatBaseView from "./poker_table_seat_base_view";
import AppData from "../../../public/const/app_data";
import ModuleManager from "../../../../framework/core/module_manager";
import ModelData, { IUserData } from "../../../public/model_data";
import PokerTableSeatBaseView from "./poker_table_seat_base_view";
import Utility from "../../../../utility/utility";
import BiPaiTableSeatView from "../../../bipai/module/table/bipai_table_seat_view";
import TableBaseView from "../table_base/table_base_view";
import TablePlayerAvatar from "../../components/table_player_avatar";

@ccclass
export default abstract class PokerTableBaseView extends TableBaseView {
    @property(cc.Button)
    buttonMask: cc.Button = null

    @property([cc.Sprite])
    bgSpriteList: cc.Sprite[] = []

    @property(cc.Label)//牌桌中间玩法说明
    lableWanFa: cc.Label = null

    @property([cc.Node])//玩家座位信息父节点
    nodeSeatParentList: cc.Node[] = []

    @property(SeatBaseView)//玩家座位信息预制
    prefabSeatView: SeatBaseView = null

    @property(cc.Button)    //聊天按钮
    buttonChat: cc.Button = null

    @property(cc.Button)    //语音按钮
    buttonMic: cc.Button = null

    @property(cc.Button)    //准备按钮
    buttonReady: cc.Button = null

    @property(cc.Button)    //离开按钮
    buttonLeave: cc.Button = null

    @property(cc.Button)    //开始按钮
    buttonStart: cc.Button = null

    @property(cc.Button)    //邀请按钮
    buttonInvite: cc.Button = null

    @property(cc.Button)
    buttonReconnect: cc.Button = null

    @property(cc.Node)
    nodeWaitMatchAnim: cc.Node = null

    private m_allSeatViewList: PokerTableSeatBaseView[] = []
    private m_posSeatMap: PokerTableSeatBaseView[] = []
    private m_localPosIndexMap: number[] = null
    private m_seatCount = 4

    private mResetSeatPosTimes: number = 0

    protected isGoldTable: boolean = false
    protected isMatchTable: boolean = false

    setIsGoldTable(isGoldTable: boolean) {
        this.isGoldTable = isGoldTable
    }

    setIsMatchTable(isMatchTable: boolean) {
        this.isMatchTable = isMatchTable
    }

    onLoad() {
        super.onLoad()
        this.initAllSeatViews()
        
        this.buttonReconnect.node.active = !!AppData.testMode
    }

    resetView() {
        this.resetAllSeat()
        this.showReadyBtn(false)
        this.showStartBtn(false)
        this.showInviteBtn(false)
        this.showChatBtn(false)
        this.showMicBtn(false)
        this.unscheduleAll()
    }

    resetAllSeat(){
        let seatList = this.m_allSeatViewList
        for (let i = 0; i < seatList.length; i++) {
            let seatList = this.m_allSeatViewList
            const seatView = seatList[i];
            seatView.reset()
            seatView.setBgStyle(true)
            this.resetSeatAll(i)
        }
    }

    resetSeatAll(i: number){
        this.showSeatClock(i, false)
        this.showSeatSelected(i, false)        
    }
    
    unscheduleAllCallbacks() {
        super.unscheduleAllCallbacks()
    }

    unscheduleAll() {
        this.unscheduleAllCallbacks()
    }

    //初始化所有的seatView
    initAllSeatViews() {
        let self = this
        let seatPosNodeList = self.nodeSeatParentList
        for (let index = 0; index < seatPosNodeList.length; index++) {
            const element = seatPosNodeList[index];
            let nodeSeat = self.instantiateObj(this.prefabSeatView.node, element)
            let seatView = nodeSeat.getComponent<PokerTableSeatBaseView>(PokerTableSeatBaseView)
            seatView.resetSeatStyle(index)
            self.m_allSeatViewList.push(seatView)
        }
    }

    getSeatCount() {
        return this.m_seatCount
    }

    setSeatCount(count) {
        this.m_seatCount = count
    }

    resetSeatViewPos() {
        let allSeats = this.m_allSeatViewList
        for (let index = 0; index < allSeats.length; index++) {
            const element = allSeats[index];
            element.node.active = false
        }
        this.m_posSeatMap = []
        let seatIndexSequence = this.getSeatIndexSequence()
        for (let index = 0; index < seatIndexSequence.length; index++) {
            const element = seatIndexSequence[index];
            let seatView = this.m_allSeatViewList[element]
            seatView.node.active = true
            this.m_posSeatMap[index] = seatView
        }
        PokerTableSeatBaseView.s_avatarSpriteCacheManager.cleanExcessCaches()
        ++this.mResetSeatPosTimes
    }

    hasFirstTimeResetSeatViewPos() {
        return this.mResetSeatPosTimes > 0
    }

    abstract getSeatIndexSequence(): number[];

    protected convertLocalPosToIndex(localPos: number): number {
        if (this.m_localPosIndexMap == null) {
            this.m_localPosIndexMap = this.getSeatIndexSequence()
        }
        return this.m_localPosIndexMap[localPos]
    }

    getSeatViewByPos<T extends PokerTableSeatBaseView>(pos: number): T {
        return this.m_posSeatMap[pos] as T
    }

    instantiateObj(prefabNode: cc.Node, parent: cc.Node): cc.Node {
        var node = cc.instantiate(prefabNode)
        node.position = cc.v2(0, 0)
        node.scale = 1
        node.parent = parent
        return node
    }

    //获取用户头像昵称相关数据
    getUserMessage(playerId: number, userCallback: Function, noCache?: boolean, remoteCallback?: Function) {
        let roleData = this.getCachedUserData(playerId)
        if (roleData != null) {
            return userCallback(roleData)
        }
        let requestData: IHttpRequestData = {
            baseUrl: "user/info?",
        }
        requestData.params["uid"] = playerId
        // requestData.remoteCallback = remoteCallback
        this.apiHttpGet(requestData, function (respone) {
            noCache && ModelData.instance.refreshRoleData(respone.data)
            userCallback(respone.data)
        })
    }

    showSeatInfo(pos: number, playerId: number, onGetUserInfoCallback?: Function, noCache?: boolean) {
        let self = this
        let seatView = self.getSeatViewByPos(pos)
        seatView.showRoleInfo(playerId != 0)
        seatView.showNoSeatDown(playerId == 0)
        seatView.enableNotSeatBtn(playerId == 0)
        if (playerId != 0) {
            let avatar = self.getAvatarById(pos)
            if(!avatar){
                avatar = self.addAvatarById(pos, playerId, seatView.avatarNodeParent)
            }
            avatar.show(true, playerId)
            self.getUserData(playerId, function(data: IUserData){                
                if (self && self.nodeIsValid && onGetUserInfoCallback != null) {
                    onGetUserInfoCallback(data)
                }
            })
            
        } else {
            self.removeAvatarById(pos)
        }
    }

    showSeatScore(pos: number, show: boolean, score?: number) {
        let avatar = this.getAvatarById(pos)
        if(!avatar){
            return
        }
        avatar.showCoinBalance(show)
        show && avatar.refreshCoinBalance(score)
    }

    showSeatOffLineTag(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showOffLineTag(show)
    }

    showSeatTmpLeaveTag(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showTmpLeaveTag(show)
    }

    showSeatReady(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showReadyTag(show)
    }

    showSeatOwnerTag(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showOwnerTag(show)
    }

    showSeatBankerTag(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showBankerTag(show)
    }

    playSetBankerAnim(pos: number, onFinish?: Function){
        let seatView = this.getSeatViewByPos(pos) as BiPaiTableSeatView
        seatView.playSetBankerAnim(onFinish)
    }

    showSeatKickBtn(pos: number, show: boolean) {
        let seatView = this.getSeatViewByPos(pos)
        seatView.showKickBtn(show)
    }

    getCachedUserData(playerId: number) {
        return null;
    }

    showReadyBtn(show: boolean) {
        if (this.buttonReady != null) {
            this.buttonReady.node.active = show
        }
    }

    showLeaveBtn(show: boolean) {
        if (this.buttonLeave != null) {
            this.buttonLeave.node.active = show
        }
    }

    showStartBtn(show: boolean) {
        if (this.buttonStart != null) {
            this.buttonStart.node.active = show
        }
    }

    showInviteBtn(show: boolean) {
        if (this.buttonInvite != null) {
            this.buttonInvite.node.active = show
        }
    }

    showChatBtn(show: boolean) {
        if (this.buttonChat != null) {
            this.buttonChat.node.active = show
        }
    }

    showMicBtn(show: boolean) {
        if (this.buttonMic != null) {
            this.buttonMic.node.active = show
        }
    }

    showSeatClock(localPos: number, show: boolean, secs?: number, needShake?: boolean, onFinish?: Function) {
        let seatView = this.getSeatViewByPos(localPos)
        seatView.showClock(show, secs, needShake, onFinish)
    }

    showSeatSelected(localPos: number, show: boolean) {
        let seatView = this.getSeatViewByPos<PokerTableSeatBaseView>(localPos)
        seatView.showSelect(show)
    }

    showSeatCoinBalance(localPos: number, show: boolean, coinBalance?: number) {
        if(localPos == 0){
            cc.warn(coinBalance, 'coinBalance-------')
        }
        let avatar = this.getAvatarById(localPos)
        if(!avatar){
            return
        }
        avatar.showCoinBalance(show)
        show && avatar.refreshCoinBalance(coinBalance)
    }

    setBgStyle(localPos: number, normal: boolean) {
        let seatView = this.getSeatViewByPos<PokerTableSeatBaseView>(localPos)
        seatView.setBgStyle(normal)
    }

    showWaitMatchAnim(show: boolean) {
        if (!this.nodeWaitMatchAnim) {
            return
        }
        this.nodeWaitMatchAnim.active = show
    }

    showWanFaLabel(show: boolean, text?: string) {
        this.lableWanFa.node.active = show
        if (show) {
            this.lableWanFa.string = text
        }
    }

    showMatchRankInfo(show: boolean, data?: any) {

    }

    setMatchRankBtnClickCallback(callback: Function) {

    }
}
